





































































import { Component, Vue } from 'vue-property-decorator';
import Loading from '@/components/Loading.vue';
import { GetterNames } from '@/constants/GetterNames';
import ModalAddLicense from '@/components/ModalAddLicense.vue';
import { ActionNames } from '@/constants/ActionNames';
import { ILicense } from '@/interfaces/ILicense';
import { MutationNames } from '@/constants/MutationNames';

@Component({
  components: {
    Loading,
    ModalAddLicense,
  },
})
export default class LicenseList extends Vue {
  public loadingPrimary: boolean = true;

  public loadingSub: boolean = true;

  public changeLicense: boolean = false;

  public error: {
    type: string,
    message: string,
    show: boolean,
  } = {
    show: false,
    type: '',
    message: '',
  };

  get primaryLicense(): string {
    return this.$store.getters[GetterNames.PRIMARY_LICENSE];
  }

  get licenses(): ILicense[] {
    return this.$store.getters[GetterNames.LICENSES];
  }

  public mutateLicense(license: string) {
    this.$store.commit(MutationNames.UPDATE_PRIMARY_LICENSE, license);
  }

  public async mounted() {
    const successOne = await this.$store.dispatch(ActionNames.GET_PRIMARY_LICENSE);

    this.loadingPrimary = false;

    const successTwo = await this.$store.dispatch(ActionNames.GET_LICENSES);

    if (!successOne || !successTwo) {
      this.error = {
        show: true,
        type: 'warning',
        message: 'Er ging iets mis tijdens het ophalen van je kentekens',
      };
    }
    this.loadingSub = false;
  }

  public async removeLicense(license: ILicense) {
    this.loadingSub = true;

    const success = await this.$store.dispatch(ActionNames.DELETE_LICENSE, license);

    if (success) {
      this.error = {
        show: true,
        type: 'success',
        message: `Nummerplaat ${license.license} is verwijderd`,
      };
    } else {
      this.error = {
        show: true,
        type: 'warning',
        message: 'Er ging iets mis tijdens het verwijderen van je nummerplaat',
      };
    }

    this.loadingSub = false;
  }

  public async updateLicense() {
    if (this.changeLicense) {
      this.loadingPrimary = true;

      const success = await this.$store.dispatch(ActionNames.UPDATE_USER_DATA, {
        license: this.primaryLicense,
      });

      if (success) {
        this.error = {
          show: true,
          type: 'success',
          message: 'Je hoofdnummerplaat is veranderd',
        };
      } else {
        this.error = {
          show: true,
          type: 'warning',
          message: 'Er ging iets mis tijdens het veranderen van je hoofdnummerplaat',
        };
      }

      this.loadingPrimary = false;
    }

    this.changeLicense = !this.changeLicense;
  }
}
